module.exports = __webpack_public_path__ + "img/video_vote.d3812824.png";